export const isInIframe = () => {
  try {
    return window.top !== window.self;
    // ? If will be throw error iframe and parent window has different origin
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_) {
    return true;
  }
};
